<div *ngIf="!configMode" class="non-config-mode-container">
    <p *ngIf="eventNotAvailable" class="the-event-is-no-longer-available">
        <span translate>THE_EVENT_IS_NO_LONGER_AVAILABLE</span>
    </p>
    <azavista3-apexcharts-wrapper *ngIf="definition.data" #displayModeChart [series]="series" [labels]="labels"
        [type]="chart.type" [width]="chart.width" [height]="chart.height"
        (dataPointSelected)="onDataPointSelected($event)">
    </azavista3-apexcharts-wrapper>
</div>

<div *ngIf="configMode" class="config-mode-container">
    <div class="settings-container">
        <div class="setting-item">
            <div class="aza-pa-flex-row">
                <div *ngIf="event" class="aza-pa-flex-row">
                    <span translate>EVENT</span>:
                    <span>{{event.name}}</span>
                </div>
                <azavista-button *ngIf="!isEventPredefined" (click)="onSelectEvent()">
                    <span translate>SELECT_EVENT</span>
                </azavista-button>
            </div>
        </div>
        <div class="setting-item">
            <mat-form-field>
                <mat-select (selectionChange)="chartTypeChanged($event.value)"
                    [(value)]="definition.settings.local.chartType" placeholder="{{'CHART_TYPE' | translate}}">
                    <mat-option value='bar'>Bar</mat-option>
                    <mat-option value='donut'>Donut</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div *ngIf="stages" class="setting-item">
            <mat-form-field>
                <mat-select multiple (selectionChange)="displayStagesChanged()"
                    [(ngModel)]="definition.settings.local.display_stages"
                    placeholder="{{'DISPLAY_STAGES' | translate}}">
                    <mat-option *ngFor="let stage of stages" [value]="stage.id">{{ stage.name }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
</div>
